import { getSizeValue } from '../../../system';
export const withSize = ({ height, size, width, minHeight, minWidth, maxWidth, maxHeight, overflow, }) => {
    const rules = {};
    if (height !== undefined) {
        rules.height = getSizeValue(height);
    }
    if (width !== undefined) {
        rules.width = getSizeValue(width);
    }
    if (minHeight !== undefined) {
        rules.minHeight = getSizeValue(minHeight);
    }
    if (minWidth !== undefined) {
        rules.minWidth = getSizeValue(minWidth);
    }
    if (maxWidth !== undefined) {
        rules.maxWidth = getSizeValue(maxWidth);
    }
    if (maxHeight !== undefined) {
        rules.maxHeight = getSizeValue(maxHeight);
    }
    if (size !== undefined) {
        rules.height = getSizeValue(size);
        rules.width = getSizeValue(size);
    }
    if (overflow) {
        rules.overflow = overflow;
    }
    return rules;
};
